<template>
  <div class="modal fade" id="menu_item_images_pop_up" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  :disabled="uploadingItems"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title"
          >
            Add / Update Menu Item Images
          </h4>
        </div>

        <div class="modal-body">
          <span><b>Name: </b>{{menuItem.name}}</span><br/><br/>
          <span><b>Attached Images: </b>{{totalImages}}</span><br/><br/>
          <div class="form-group">
            <label>Add New Image</label><br/>
            <input type="file"
                   class="form-control"
                   id="menuItemImages"
                   title="Select images"
                   multiple
                   :disabled="uploadingItems"
                   v-on:change="attachMenuImages()">
          </div>

          <div class="form-group">
            <div class="progress"
                 id="progress"
                 style="display: none"
            >
              <div id="progress-bar"
                   class="progress-bar progress-bar-info progress-bar-striped active"
                   role="progressbar"
                   :style="{width: uploadImagePercentage+'%'}"
                   :aria-valuenow="uploadImagePercentage"
                   aria-valuemin="0"
                   aria-valuemax="100"
              >
                {{uploadImagePercentage}}%
              </div>
            </div>
          </div>

          <div class="table-responsive" style="overflow: auto">
            <table class="table table-striped table-bordered table-hover responsive">
              <thead>
              <tr>
                <th>Image</th>
                <th>Delete</th>
              </tr>
              </thead>
              <tbody>

              <tr v-for="item in menuItemImages">
                <td>
                  <img v-bind:src="item.imageUrl"
                       alt="No image found"
                       style="max-width: 20% ;max-height: 20%">
                </td>
                <td>&emsp;
                  <a href="javascript:void(0)" style="color: inherit;">
                    <i v-on:click="deleteMenuItemImage(item.id)"
                       class="fa fa-trash">
                    </i>
                  </a>
                </td>
              </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default"
                  data-dismiss="modal"
                  :disabled="uploadingItems"
          >Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {deleteMenuItemImage, getMenuItemById, uploadMenuItemImages} from "../../api/restaurants";

export default {
  name: "ViewMenuItemImages",
  data() {
    return {
      menuItem: {
        "id": 0,
        "name": "",
        "description": "",
        "mostPopular": true,
        "deleted": false,
        "disableOnBayked": true,
        "totalMenuItemImages": 0,
        "menuItemTypesById":[],
        "menuItemAdOns": [],
        "menuItemImagesByMenuItemId": [
          {
            "id" : 0,
            "imageUrl": ""
          }
        ]
      },
      menuItemImages:[ {
        "id": 0,
        "imageUrl": ""
      }],
      totalImages: 0,
      branchId: 0,
      uploadingItems: false,
      uploadImagePercentage: 0,
    }
  },
  watch:{
    menuItemImages() {
      this.totalImages = this.menuItemImages.length;
    }
  },
  methods:{
    load: async function (menuItemId, branchId) {
      await this.getMenuItemDetailsById(menuItemId);
      this.branchId = branchId;
      this.menuItemImages = this.menuItem.menuItemImagesByMenuItemId;
      $("#menu_item_images_pop_up").modal("show");
    },
    setProgressBarStyle: function (display){
      this.uploadingItems = (display === 'flex');
      document.getElementById("progress").style.display = display;
      this.uploadImagePercentage = 0;
    },
    saveImage: async function(formData){
      this.uploadingItems= true;
      this.setProgressBarStyle("flex");
      let self = this;
      let config ={
        headers: {
          'Content-Type': 'multipart/form-data;'
        },
        onUploadProgress: function (progressEvent){
          if(progressEvent.lengthComputable) {
            self.uploadImagePercentage = Math.round((progressEvent.loaded * 100)/ progressEvent.total);
          }
        }.bind(self)
      };
      let uploadMenuItemImagesResp = await uploadMenuItemImages(formData, config);
      if (uploadMenuItemImagesResp.data) {
        swal("SUCCESS!", "Successfully upload menu item image!", "success");
      } else {
        swal("Error!", "Error while uploading menu item image!", "error");
      }
      this.setProgressBarStyle("none");
    },
    attachMenuImages: async function () {
      let menuItemId= this.menuItem.id;
      let menuItemImagesSelector = $("#menuItemImages").prop('files');
      this.menuItem.totalMenuItemImages+= menuItemImagesSelector.length;
      this.uploadImages = menuItemImagesSelector.length > 0;
      let formData = new FormData();
      formData.append("branchId", this.branchId);
      formData.append("menuItemId", menuItemId);
      for (let i = 0; i < menuItemImagesSelector.length; i++) {
        let image =  menuItemImagesSelector[i];
        formData.append("menuItemImages", image);
      }
      await this.saveImage(formData);
      $("#menuItemImages").val('');
      await this.getMenuItemDetailsById(this.menuItem.id);
      this.menuItemImages = this.menuItem.menuItemImagesByMenuItemId;
    },
    deleteImages: async function(menuItemImageId){
      let params = new URLSearchParams();
      params.append("branchId", this.branchId);
      this.showLoading();
      let deleteMenuItemImageByImageIdResp = await deleteMenuItemImage(menuItemImageId, params);
      if(deleteMenuItemImageByImageIdResp.data.status === 200){
        swal("SUCCESS!", "Successfully delete menu item image!", "success");
      } else {
        swal("Error!", "Error while deleting menu item image!", "error");
      }
    },
    deleteMenuItemImage: async function (menuItemImageId){
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to delete the menu item image?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async result => {
        if (result.value) {
          await this.deleteImages(menuItemImageId);
          await this.getMenuItemDetailsById(this.menuItem.id);
          this.menuItemImages = this.menuItem.menuItemImagesByMenuItemId;
        }
      });
    },
    getMenuItemDetailsById: async function (menuItemId) {
      let menuItemImagesResp = await getMenuItemById(menuItemId);
      if(menuItemImagesResp.data.status === 200){
        this.menuItem = menuItemImagesResp.data.body;
      }else{
        swal("Error!", "Error while getting menu item image!", "error");
      }
    },
  }
}
</script>

<style scoped>

</style>